export const iconFontAwesomeCodingNotdef = (
	<i className="fa-solid fa-notdef"></i>
);
